import { Box } from "@mui/material"
import type { FC } from "react"

import type { PastChallenges } from "../../../../api/hooks/past"
import { ChallengesList } from "../../../@shared/challenges"
import { normalizeChallenges } from "./challenges.schema"

interface Props {
	loading: boolean
	challenges: PastChallenges
}

export const Listing: FC<Props> = ({ challenges, loading }) => (
	<Box mt={7}>
		<ChallengesList
			loading={loading}
			items={normalizeChallenges(challenges)}
		/>
	</Box>
)
